<div
  class="ccm-backdrop"
  role="dialog"
  aria-modal="true"
  tabindex="0"
  (click)="onBackdropClick($event)"
  (keydown.enter)="onBackdropKey($event)"
  (keydown.space)="onBackdropKey($event)"
>
  <div class="ccm-modal" @fadeScale>
    <div class="ccm-header">
      <h5 class="ccm-title">
        {{ title }}
      </h5>
      <button
        type="button"
        class="ccm-close-button"
        aria-label="Close"
        (click)="cancelHandler()"
      >
        <i class="fa-solid fa-circle-xmark"></i>
      </button>
    </div>

    <div class="ccm-body">
      <p class="ccm-description">
        {{ description }}
      </p>
    </div>

    <div class="ccm-footer">
      <button
        type="button"
        class="ccm-btn ccm-btn-secondary"
        (click)="cancelHandler()"
        [attr.aria-label]="cancelButtonLabel"
      >
        <span class="ccm-btn-content">
          <span class="ccm-btn-text">{{ cancelButtonLabel }}</span>
        </span>
        <span class="ccm-btn-ripple"></span>
      </button>

      <button
        type="button"
        class="ccm-btn ccm-btn-primary"
        [ngClass]="customClass"
        (click)="confirmHandler()"
        [attr.aria-label]="confirmButtonLabel"
      >
        <span class="ccm-btn-content">
          <span class="ccm-btn-text">{{ confirmButtonLabel }}</span>
        </span>
        <span class="ccm-btn-ripple"></span>
      </button>
    </div>
  </div>
</div>
